"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var context_1 = require("../context");
var shared_1 = require("../shared");
var Provider = context_1.BroadcastContext.Provider;
exports.FormProvider = function (props) {
    var broadcast = react_1.useMemo(function () {
        return new shared_1.Broadcast();
    }, []);
    return react_1.default.createElement(Provider, { value: broadcast }, props.children);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react/lib/components/FormProvider.js
// module id = 5765
// module chunks = 0